import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { IDocumentEngineTemplate } from '@core/entities/document-engine'
import { RequestTypes } from '../requestTypes'
import { documentEngineTemplateKeys } from '../documentEngineTemplateKeys'

export const useUpdateDocumentEngineTemplate = (
  options?: UseMutationOptions<
    IDocumentEngineTemplate,
    RequestErrorType,
    RequestTypes['updateDocumentEngineTemplate']
  >,
) => {
  const queryClient = useQueryClient()
  return useMutation({
    ...documentEngineTemplateKeys.updateDocumentEngineTemplate,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: documentEngineTemplateKeys.byTemplateId({
          organisationId: variables.organisationId,
          templateId: variables.templateId,
        }).queryKey,
      })
    },
    ...options,
  })
}
